// apps/webapp/webapp/src/redesign/popover-two-column-table/popover-two-columns.tsx

import React from 'react';
import { Box, Fade, Grid, Popover, Stack, Typography } from '@mui/material';
import { IconApproved } from 'assets/img';
import {
  ColoredIcon,
  ContentWrapper,
  FallbackCircle,
  IconWrapper,
  LabelContainer,
  PaperContainer,
  TitleContainer,
} from './popover-two-columns-styled-components';

export type PopoverTwoColumnsInfoRow = {
  label: string;
  labelIcon?: React.ReactNode;
  value: React.ReactNode;
};

export type PopoverTwoColumnsProps = {
  title: string;
  data: PopoverTwoColumnsInfoRow[];
  anchorEl?: HTMLElement | null;
  maxWidth?: number | string;
  maxHeight?: number | string;
  onMouseLeave?: () => void;
  open?: boolean;
  onClose?: () => void;
};

export const PopoverTwoColumns = ({
  title,
  data,
  maxWidth,
  maxHeight,
  anchorEl,
  open,
  onClose,
}: PopoverTwoColumnsProps) => {
  const finalOpen = open !== undefined ? open : Boolean(anchorEl);

  return (
    <Popover
      open={finalOpen}
      sx={{ pointerEvents: 'none' }}
      anchorEl={anchorEl}
      onClose={onClose}
      disableEnforceFocus={true}
      TransitionComponent={Fade}
      TransitionProps={{ timeout: 0 }}
      disableRestoreFocus
      disableAutoFocus={true}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'center',
        horizontal: 'right',
      }}
      PaperProps={{
        sx: {
          width: maxWidth,
          maxHeight: maxHeight,
          padding: 2,
          overflow: 'hidden',
          borderRadius: 3,
          boxShadow: '0 10px 30px rgba(32, 45, 77, 0.12), 0 6px 12px rgba(32,45,77,0.06)',
        },
      }}
    >
      <Box>
        <PaperContainer>
          <TitleContainer>
            <IconApproved width={24} height={24} />
            <Typography variant="h6" fontWeight={700}>
              {title}
            </Typography>
          </TitleContainer>

          <ContentWrapper>
            <Grid container spacing={2}>
              {data.map((row, idx) => (
                <Grid key={idx} item xs={12}>
                  <Stack direction="row" spacing={2} justifyContent={'space-between'}>
                    <LabelContainer>
                      <IconWrapper>
                        {row.labelIcon ? (
                          <ColoredIcon>{row.labelIcon}</ColoredIcon>
                        ) : (
                          <FallbackCircle aria-hidden>{row.label.substring(0, 1)}</FallbackCircle>
                        )}
                      </IconWrapper>

                      <Typography variant="body2" fontWeight={600}>
                        {row.label}
                      </Typography>
                    </LabelContainer>
                    <Box
                      sx={{
                        flex: 1,
                        display: 'flex',
                        justifyContent: 'flex-end',
                        textAlign: 'right',
                        overflow: 'hidden',
                      }}
                    >
                      {typeof row.value === 'string' ? (
                        <Typography variant="body1" fontWeight={600} textOverflow={'ellipsis'}>
                          {row.value}
                        </Typography>
                      ) : (
                        row.value
                      )}
                    </Box>
                  </Stack>
                </Grid>
              ))}
            </Grid>
          </ContentWrapper>
        </PaperContainer>
      </Box>
    </Popover>
  );
};
